const cookie = {
  /**
   * 对于所有能保存本地记录的地方进行保存
   * @param {String} name  字段名
   * @param {String|Object} value 存储值
   */
  setEverCookie: function setEverCookie(name, value) {
    this.setCookie(name, value);
    this.setLocalStorage(name, value);
  },


  /**
   * 本地强保留
   * @param  {String} name 本地存储字段名
   * @return {String}      对应本地存储信息
   */
  getEverCookie: function getEverCookie(name) {
    var result = this.getCookie(name);

    if (!result) {
      result = this.getLocalStorage(name);
    }
    return result;
  },


  /**
   * @desc 设置 cookie，只有统计在用
   * @param name 名
   * @param value 值
   */
  setCookie: function setCookie(name, value, day, domain, path) {
    var Days = day || 30,
      exp = new Date();

    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + (path ? ";path=" + path : ";path=/") + (domain ? ';domain=' + domain : '');
  },


  /**
   * @desc 设置 cookie，只有统计在用
   * @param name 名
   * @param value 值
   * @param min cookie时长，分钟级别，默认30分钟
   */
  setShortCookie: function setShortCookie(name, value, min, domain, path) {
    var mins = min || 30,
      exp = new Date();

    exp.setTime(exp.getTime() + mins * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + (path ? ";path=" + path : ";path=/") + (domain ? ';domain=' + domain : '');
  },


  /**
   * @desc 获取 cookie，只有统计在用
   * @param name 名
   * @returns {string}
   */
  getCookie: function getCookie(name) {
    var arr = void 0,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return '';
    }
  },
  setLocalStorage: function setLocalStorage(name, value) {
    try {
      if (window.localStorage) {
        if (typeof value  === 'object') {
          value = JSON.stringify(value);
        }

        window.localStorage.setItem(name, value);
      }
    } catch (e) {}
  },
  getLocalStorage: function getLocalStorage(name) {
    try {
      if (window.localStorage) {
        return window.localStorage.getItem(name);
      }
    } catch (e) {}
    return null;
  }
}
export default cookie